import React from 'react';
import {FaFacebook,FaLinkedin,FaInstagram} from 'react-icons/fa'

 export  const socialData=[
    {id:1,icon:<FaFacebook className="icon" />,url:"https://www.facebook.com"},
     {id:2,icon:<FaLinkedin className="icon" />,url:"https://www.facebook.com"},
      {id:3,icon:<FaInstagram className="icon" />,url:"https://www.facebook.com"}
]